<!-- <div *ngIf="visualStateService.shouldShowMoreResults && !layoutState.inSlideshowMode"
    class="fs12 mb-4 show-all w100">
    {{PSTWebFirstX}}
    <span class="pointer underline" (click)="loadAllResults()">
        {{languageSettings.PSTWebLoadAll}}
    </span>
</div> -->
<div class="st-filter__header">
    <span class="st-filter__header__title">{{ viewStateFilterLabel$ | ngrxPush }}</span>
    <div class="st-filter__header__actions">
        <button
            mat-icon-button
            class="st-filter__header__actions-button"
            [matTooltip]="languageSettings.PSTWebPinFilterLabel"
            (click)="toggleFilterElevation()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-filter__header__actions-icon"
                >push_pin</mat-icon
            >
        </button>
        <button
            mat-icon-button
            class="st-filter__header__actions-button"
            [matTooltip]="languageSettings.PSTWebDialogAboutCloseLabel"
            (click)="closeFilter.emit()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-filter__header__actions-icon"
                >close</mat-icon
            >
        </button>
    </div>
</div>

@if (isSingleViewStateRecord$ | ngrxPush) {
    <ng-template [ngIf]="isSingleViewStateRecord$ | ngrxPush">
        <div class="st-filter-body">
            <mat-button-toggle-group
                name="filterType"
                aria-label="Type"
                class="st-filter-full-width"
                [(ngModel)]="filterType">
                <mat-button-toggle
                    class="st-filter-full-width-button-toggle"
                    [value]="filterTypes.REQUIRED">
                    <mat-icon
                        *ngIf="filterType === filterTypes.REQUIRED"
                        class="material-symbols-outlined">
                        check
                    </mat-icon>
                    {{ languageSettings.PSTWebRequiredFiltersLabel }}</mat-button-toggle
                >
                <mat-button-toggle
                    class="st-filter-full-width-button-toggle"
                    [value]="filterTypes.OPTIONAL">
                    <mat-icon
                        *ngIf="filterType === filterTypes.OPTIONAL"
                        class="material-symbols-outlined">
                        check
                    </mat-icon>
                    {{ languageSettings.PSTWebOptionalFiltersLabel }}</mat-button-toggle
                >
            </mat-button-toggle-group>
            <st-filter-list
                *ngIf="filterType === filterTypes.REQUIRED"
                [disabled]="isViewStateSortingManual$ | ngrxPush"
                [filters]="viewStateRequiredFilters$ | ngrxPush"
                [filterType]="filterTypes.REQUIRED"
                (update)="onUpdateFilter()"
                (remove)="onRemoveFilter($event, filterTypes.REQUIRED)" />
            <st-filter-list
                *ngIf="filterType === filterTypes.OPTIONAL"
                [disabled]="isViewStateSortingManual$ | ngrxPush"
                [filters]="viewStateOptionalFilters$ | ngrxPush"
                [filterType]="filterTypes.OPTIONAL"
                (update)="onUpdateFilter()"
                (remove)="onRemoveFilter($event, filterTypes.OPTIONAL)" />
            <button
                *ngIf="filterType === filterTypes.REQUIRED"
                mat-raised-button
                class="st-filter-add"
                [matMenuTriggerFor]="listRequiredFilterDropDownMenu"
                [disabled]="isViewStateSortingManual$ | ngrxPush">
                {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
            </button>
            <mat-menu #listRequiredFilterDropDownMenu="matMenu">
                <mat-selection-list
                    st-click-stop-propagation
                    [ngModel]="viewStateRequiredFiltersIDs$ | ngrxPush"
                    (selectionChange)="onFilterStateChange($event, true)">
                    @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                        <mat-list-option
                            [disabled]="!item.NotUsed && item.IsOptional"
                            [value]="item.ID"
                            [dir]="isRTL">
                            {{ item.DefaultCaption }}
                        </mat-list-option>
                    }
                </mat-selection-list>
            </mat-menu>

            <button
                *ngIf="filterType === filterTypes.OPTIONAL"
                mat-raised-button
                class="st-filter-add"
                [matMenuTriggerFor]="listOptionalFilterDropDownMenu"
                [disabled]="isViewStateSortingManual$ | ngrxPush">
                {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
            </button>
            <mat-menu #listOptionalFilterDropDownMenu="matMenu">
                <mat-selection-list
                    st-click-stop-propagation
                    [ngModel]="viewStateOptionalFiltersIDs$ | ngrxPush"
                    (selectionChange)="onFilterStateChange($event, false)">
                    @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                        <mat-list-option
                            [disabled]="!item.NotUsed && item.IsRequired"
                            [value]="item.ID"
                            [dir]="isRTL">
                            {{ item.DefaultCaption }}
                        </mat-list-option>
                    }
                </mat-selection-list>
            </mat-menu>
        </div>
    </ng-template>
}

@if (isManageTeamMembers) {
    <ng-template [ngIf]="isManageTeamMembers">
        <div class="st-filter-body">
            <mat-button-toggle-group
                name="filterType"
                aria-label="Type"
                class="st-filter-full-width"
                [(ngModel)]="filterType">
                <mat-button-toggle
                    class="st-filter-full-width-button-toggle"
                    [value]="filterTypes.REQUIRED">
                    <mat-icon
                        *ngIf="filterType === filterTypes.REQUIRED"
                        class="material-symbols-outlined">
                        check
                    </mat-icon>
                    {{ languageSettings.PSTWebRequiredFiltersLabel }}</mat-button-toggle
                >
                <mat-button-toggle
                    class="st-filter-full-width-button-toggle"
                    [value]="filterTypes.OPTIONAL">
                    <mat-icon
                        *ngIf="filterType === filterTypes.OPTIONAL"
                        class="material-symbols-outlined">
                        check
                    </mat-icon>
                    {{ languageSettings.PSTWebOptionalFiltersLabel }}</mat-button-toggle
                >
            </mat-button-toggle-group>
            <st-filter-manage-team-members [type]="filterType" />
        </div>
    </ng-template>
}

@if (isPlanningViews) {
    <ng-template [ngIf]="isPlanningViews">
        <div class="st-filter-body">
            <st-filter-planning-views />
        </div>
    </ng-template>
}
